import axios from 'axios'
import { generateResponse, generateErrorResponse } from './common'

const Promise = window.Promise || require('promise')
const API_END_POINT = process.env.API_END_POINT
const CHECK_AUTH = API_END_POINT + '/auth/check'
const UPDATE = API_END_POINT + '/users/'
const RESUMES = API_END_POINT + '/users/resume'
const RESUME_FOLDERS = API_END_POINT + '/users/resume/folder'
const RECRUIT = API_END_POINT + '/users/recruit'
const INTERNSHIP_EXPERIENCES = API_END_POINT + '/users/internship'
const USER_SAVED = API_END_POINT + '/users/save/'
const SKILLS = API_END_POINT + '/skills'

const RESEND_ACTIVE_ACCOUNT_EMAIL = API_END_POINT + '/auth/resentactiveaccountemail'

export default {
  API_END_POINT: API_END_POINT,
  reSentActiveAccountEmail (token) {
    return axios({
      url: RESEND_ACTIVE_ACCOUNT_EMAIL,
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  removeRecruited (token, params) {
    return axios({
      url: RECRUIT,
      method: 'delete',
      data: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getRecruited (token, params) {
    return axios({
      url: RECRUIT,
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  recruit (token, data) {
    return axios({
      url: RECRUIT + '/' + data.resumeId,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getFolders (token) {
    return axios({
      url: RESUME_FOLDERS,
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  updateFolder (token, data) {
    let options = {
      url: '',
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + token
      }
    }
    if (data.type === 'deleted') {
      options.url = RESUME_FOLDERS + '/' + data.folderId
      options.method = 'delete'
    } else {
      if (data.folderId === 0) {
        options.url = RESUME_FOLDERS
      } else {
        options.url = RESUME_FOLDERS + '/' + data.folderId
      }
    }
    options.data = data
    return axios(options)
      .then(generateResponse, generateErrorResponse)
  },
  addSavedToFolder (token, data) {
    return axios({
      url: RESUME_FOLDERS,
      method: 'put',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  deleteSkillById (token, id, data) {
    return axios({
      url: SKILLS + '/' + id,
      method: 'delete',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  addSkill (token, data) {
    return axios({
      url: SKILLS,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getSkills (token, params = { page: 1 }) {
    return axios({
      url: SKILLS,
      method: 'gst',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  deleteSaved (token, type = 'user', data) {
    return axios({
      url: USER_SAVED + type,
      method: 'delete',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  addSaved (token, type = 'user', data) {
    return axios({
      url: USER_SAVED + type + '/' + data.id,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getSaved (token, type = 'user', params = { page: 1 }) {
    return axios({
      url: USER_SAVED + type,
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  delResumeById (token, id) {
    return axios({
      url: RESUMES,
      method: 'delete',
      data: {
        resumeId: id
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  updateResumeById (token, data) {
    return axios({
      url: RESUMES,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  addResume (token, data) {
    return axios({
      url: RESUMES,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getResumeById (token, id) {
    return axios({
      url: RESUMES,
      method: 'get',
      params: {
        resumeId: id
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getResumes (token, params = { page: 1 }) {
    return axios({
      url: RESUMES,
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  deleteInternshipExperiencesById (token, id) {
    return axios({
      url: INTERNSHIP_EXPERIENCES,
      method: 'delete',
      data: {
        internshipExperienceId: id
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  updateInternshipExperiencesById (token, data) {
    return axios({
      url: INTERNSHIP_EXPERIENCES,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  addInternshipExperiences (token, data) {
    return axios({
      url: INTERNSHIP_EXPERIENCES,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getInternshipExperienceById (token, id) {
    return axios({
      url: INTERNSHIP_EXPERIENCES,
      method: 'get',
      params: {
        internshipExperienceId: id
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getInternshipExperiences (token, params = { page: 1 }) {
    return axios({
      url: INTERNSHIP_EXPERIENCES,
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  updateById (id, token, data) {
    return axios({
      url: UPDATE + id,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getById (id, token) {
    return axios({
      url: UPDATE + id,
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  get (token) {
    if (typeof token !== 'undefined' && token !== '') {
      return axios({
        url: CHECK_AUTH,
        method: 'get',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    } else {
      return Promise.reject({
        status: 'err',
        messages: ''
      }).then(generateResponse, generateErrorResponse)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js